<template>
	<div class="logout">
	</div>
</template>
<script>
	import moment from 'moment';
	export default {
		name: 'logout',
		components: {
		},
		data:function(){
			return{
			}
		},
		mounted: function(){
			var self = this;			
			self.$cookies.remove("username");
			self.$cookies.remove("user_level");
			self.$cookies.remove("auth_token");
			self.$cookies.remove("school_id");
			self.$cookies.remove("school_name");
			self.$cookies.remove("school_chi_name");
			self.$cookies.remove("booking_id");
			self.$cookies.remove("experiment");
			self.$cookies.remove("equipment_id");
			self.$cookies.remove("session_token");
			self.$cookies.remove("role");
			self.$cookies.remove("end_at");
			self.$cookies.remove("kick_timestamp");

			let username = null;
			let school_id = null;
			let school_name = null;
			let school_chi_name = null;
			let user_level = null;
			let logged_in = false;
			let auth_token = null;
			self.$store.commit("updateUserInfo", {username, user_level, school_id, school_name, school_chi_name, logged_in, auth_token});
			self.$router.push("/");
// 			window.location.href = process.env.VUE_APP_BASE_URL;
		},
		methods:{
		}
	}
</script>